import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { FileAttachment } from '~hooks/useFileAttachment/models';

interface DescriptionColumnProps {
  file: FileAttachment;
  sx?: SxProps<Theme>;
}

export default function DescriptionColumn({ file, sx }: DescriptionColumnProps) {
  const { description } = file;

  return (
    <Box sx={{ ...sx, overflow: 'hidden' }}>
      <OverflowAwareText>{description ?? '-'}</OverflowAwareText>
    </Box>
  );
}
